/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-01-25 16:42:54
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-06 22:54:46
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Modal/WarningModal1.tsx
 */
import Modal from './Modal';
import css from './Modal.less';
import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import Footer from './ModalFooter';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Warning = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const {
    header,
    onOk,
    okText,
    onCancel,
    cancelText,
    children,
    visible,
    ...rest
  } = props;
  const [_visible, _setVisible] = React.useState(visible);
  const handleOnCancel = () => {
    if (onCancel) onCancel();
    _setVisible(false);
  };
  const handleOnOk = () => {
    if (onOk) onOk();
    _setVisible(false);
  };
  const title = (
    <div className={css.modalHeader}>
      <InfoCircleFilled
        className={css.headerIcon}
        style={{ color: '#ff695f' }}
      />
      {header}
    </div>
  );
  return (
    <Modal
      className={css.themeHeader}
      visible={_visible}
      title={title}
      onCancel={handleOnCancel}
      cancelText={getI18n('general.cancel')}
      {...rest}>
      <Content
        onOk={handleOnOk}
        okText={okText}
        cancelText={cancelText}
        onCancel={handleOnCancel}>
        {children}
      </Content>
      {/* <div className={css.contentContainer}> {children}</div>
      <Footer
        okClassName={css.dangerousBtn}
        onOk={handleOnOk}
        okText={okText}
        cancelText={cancelText}
        onCancel={handleOnCancel}
      /> */}
    </Modal>
  );
};
export default Warning;
const Content = (props) => {
  const { children, onOk, okText, cancelText, onCancel } = props;
  return (
    <React.Fragment>
      <ContentContainer> {children}</ContentContainer>
      <Footer
        okClassName={css.dangerousBtn}
        onOk={onOk}
        okText={okText}
        cancelText={cancelText}
        onCancel={onCancel}
      />
    </React.Fragment>
  );
};
const ContentContainer = (props) => {
  const { children } = props;
  return <div className={css.contentContainer}> {children}</div>;
};
export { Content, ContentContainer };
